import React, { useEffect, useState } from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import { Button, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { FormikInput, FormikSelect } from '../../components';
import JobManagementsFilter from '../../components/Utils/Filters/JobManagementsFilter';
import JobTitlesFilter from '../../components/Utils/Filters/JobTitlesFilter';
import CostCentersFilter from '../../components/Utils/Filters/CostCentersFilter';
import { indexEmployeesRequest } from '../../requests/employees';
import { periods } from './FormOptions';

const resultFetchWorkers = response => {
  const result = response.data.data;
  return result.map(element => ({
    ...element,
    label: element.full_name,
    value: element.id
  }));
};

const DncFilter = props => {
  const { errors, touched, setFieldValue } = props;
  const [workers, setWorkers] = useState([]);
  const dispatch = useDispatch();

  const years = Array.from({ length: 21 }, (_, i) => {
    const y = 2020 + i;
    return { label: y.toString(), value: y };
  });

  useEffect(() => {
    indexEmployeesRequest({
      dispatch,
      params: {
        active: true,
        is_dt: false,
        paginate: false,
        sort_column: 'name'
      },
      successCallback: res => setWorkers(resultFetchWorkers(res))
    });
  }, [dispatch]);

  return (
    <Form className="absence-filter-form pt-2 px-3 mt-2">
      <Row>
        <Col xs={12} md={3}>
          <Field name="filterYear">
            {({ field }) => (
              <FormikSelect
                {...field}
                abbr
                label="Año"
                placeholder="Seleccionar año"
                options={years}
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={12} md={3}>
          <Field name="filterPeriod">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Periodo"
                placeholder="Seleccionar periodo"
                options={periods}
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={12} md={3}>
          <Field name="filterRut">
            {({ field, form }) => (
              <FormikInput
                {...field}
                label="Rut"
                placeholder="Sin puntos y sin guion"
                onChange={e => form.setFieldValue(field.name, e.target.value)}
                error={getIn(form.touched, field.name) && getIn(form.errors, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={12} md={3}>
          <Field name="filterEmployeeIds">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Colaboradores"
                isMulti
                options={workers}
                placeholder="Seleccione colaboradores"
                onChange={data => setFieldValue(field.name, data ? data.map(d => d.value) : [])}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} md={3}>
          <JobTitlesFilter formikValue="filterJobTitleId" params={{}} />
        </Col>
        <Col xs={12} md={3}>
          <JobManagementsFilter formikValue="filterJobManagementId" params={{}} />
        </Col>
        <Col xs={12} md={3}>
          <CostCentersFilter formikValue="filterCostCenter" params={{}} />
        </Col>
        <Col xs={12} md={3}>
          <Field name="filterDirectLeaderIds">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Jefe Directo"
                isMulti
                options={workers}
                placeholder="Seleccione jefes"
                onChange={data => setFieldValue(field.name, data ? data.map(d => d.value) : [])}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row className="my-3">
        <Col xs={12} md={{ span: 2, offset: 10 }} className="d-flex align-items-end justify-content-end">
          <Button type="submit" className="btn-block btn-primary mb-3">
            FILTRAR
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const validationSchema = Yup.object().shape({
  filterYear: Yup.string().required('Requerido')
});

const setInitialValues = () => {
  return {
    filterYear: '',
    filterPeriod: '',
    filterRut: '',
    filterEmployeeIds: [],
    filterJobTitleId: '',
    filterJobManagementId: '',
    filterCostCenter: '',
    filterDirectLeaderIds: []
  };
};

const handleSubmit = (values, { props }) => {
  const { formRequest } = props;
  formRequest(values);
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: true
})(DncFilter);
